import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import './AlpacaPortfolio.css';

const NotificationsTelegram = () => {
  const { token } = useAuth();
  const [message, setMessage] = useState('Hello depuis Technonet 👋');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const send = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');
    try {
      const res = await fetch('/api/notifications/telegram/send', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { 'Authorization': `Bearer ${token}` } : {})
        },
        body: JSON.stringify({ message })
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.message || data.error || 'Erreur lors de l\'envoi');
      } else {
        setSuccess('Notification envoyée sur Telegram ✅');
      }
    } catch (err) {
      setError('Erreur de connexion au serveur');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="portfolio-page">
      <div className="portfolio-header">
        <h1 className="portfolio-title">🔔 Notifications - Telegram</h1>
        <p className="portfolio-subtitle">Envoyer un message de test via le bot Telegram configuré</p>
      </div>

      {error && <div className="error-message">{error}</div>}
      {success && <div className="message success" style={{background:'#d1fae5',border:'1px solid #a7f3d0',color:'#065f46',padding:'1rem',borderRadius:'8px',marginBottom:'1.5rem'}}> {success} </div>}

      <div className="section">
        <h2>Envoyer une notification</h2>
        <div className="section-body">
          <form onSubmit={send} style={{display:'flex',gap:'1rem',alignItems:'center'}}>
            <input
              type="text"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Votre message"
              style={{flex:1,padding:'0.75rem',border:'1px solid #d1d5db',borderRadius:'8px'}}
              required
            />
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? '⏳ Envoi...' : '📨 Envoyer'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NotificationsTelegram;


